import { gql, TypedDocumentNode } from '@common/hooks';
import {
  OrganizationOnDemandSettingsQueryCgResponse,
  OrganizationOnDemandSettingsQueryVariables,
} from '@common/graphql';

export const OrganizationOnDemandSettingsQuery: TypedDocumentNode<
  OrganizationOnDemandSettingsQueryCgResponse,
  OrganizationOnDemandSettingsQueryVariables
> = gql`
  query OrganizationOnDemandSettings {
    organizationOnDemandSettings {
      allowListsEditWithSync
    }
  }
`;
